import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutAgenciesWithPrimary extends Layout {
    agencyLinkTable: Table;
    layoutheaderResponsibilityUsers: LayoutHeader;
    sourceAgencyLink: DataSource;
}
